import kartleggingReducer from "./kartleggingReducer";

export * from "./kartleggingReducer";

export default kartleggingReducer;
